import { createFileRoute } from '@tanstack/react-router'
import { ForgingsReportingPage } from 'pages/forgingsReporting/ForgingsReportingPage'

export const Route = createFileRoute('/forgings-reporting/')({
  component: RouteComponent,
  staticData: {
    layout: { enableScrolling: true, showSearchBar: false },
  },
})

function RouteComponent() {
  const { orgId, siteId } = Route.useSearch()
  return <ForgingsReportingPage orgId={orgId} siteId={siteId} />
}
